<script>
import { mapGetters } from 'vuex';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator.vue';
import SelectionFullForm from './SelectionFullForm.vue';

export default {
  name: 'FormGuideFullForm',
  components: {
    LoadingIndicator,
    SelectionFullForm,
  },
  props: {
    slug: {
      type: String,
      default: '',
    },
    eventNumber: {
      type: String,
      default: '',
    },
    eventId: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      selections: 'FormGuideFullForm/getSelectionData',
    }),
    orderedSelections() {
      const { selections } = this;
      return selections.length > 0
        ? selections.sort((a, b) => {
            return a.competitor_number - b.competitor_number;
          })
        : [];
    },
  },
  mounted() {
    const { slug, eventNumber, eventId } = this;
    if (eventId) {
      this.$store.dispatch('FormGuideFullForm/fetchEventSelectionById', eventId);
    } else {
      this.$store.dispatch('FormGuideFullForm/fetchEventSelectionBySlug', { slug, eventNumber });
    }
  },
};
</script>

<template>
  <div class="form-guide-full-form">
    <!-- Loading template -->
    <template v-if="!selections">
      <LoadingIndicator />
    </template>
    <!-- Selections -->
    <template v-else>
      <SelectionFullForm
        v-for="(selection, index) in orderedSelections"
        :key="`selection-ff-${index}`"
        :selection="selection"
      />
    </template>
  </div>
</template>
